define([], () => {
    const SCRIPT_ID = 'mygento-ymaps';

    let isInitialized = false;
    let callbacks = [];

    function executeCallbacks() {
        const callbacksLength = callbacks.length;

        for (let i = 0; i < callbacksLength; i++) {
            if (!callbacks.length) {
                break;
            }

            const callback = callbacks.shift();
            callback();
        }
    }

    function onLoadSuccess() {
        isInitialized = true;
        executeCallbacks();
    }

    function isScriptExists() {
        return Boolean(document.getElementById(SCRIPT_ID));
    }

    function addScriptToDocument() {
        const script = document.createElement('script');
        script.id = SCRIPT_ID;

        const tmpKey = window.ymapsKey; // ymapsKey

        script.src = `https://api-maps.yandex.ru/2.1/?apikey=${tmpKey}&lang=ru-RU`;
        script.onload = onLoadSuccess;

        document.body.appendChild(script);
    }

    return function (callback) {
        callbacks.push(callback);

        if (isScriptExists() && !isInitialized) {
            return;
        }

        if (isScriptExists && isInitialized) {
            executeCallbacks();
            return;
        }

        addScriptToDocument();
    };
});
